import React from 'react';
import {Col} from 'react-bootstrap';
import CurrencyInput from 'react-currency-input';
import AbstractComponent from '../../AbstractComponent';

class InputMoeda extends AbstractComponent {  
    constructor(props) {
        super(props);

        this.state = {
            tooltip: false
        }
    }      
    
    erro() {
        if(Array.isArray(this.props.erro)) {
            return(
                <ul>
                    {this.props.erro.map( (item , i) => {
                        return (
                            <li key={i}>{item}</li>
                        )
                    })}
                </ul>
            )
        }

        return this.props.erro;
    }    
    
    classErro() {
        return this.props.erro !== undefined && this.props.erro !== '' ? 'form-controll-erro' : '';
    }                
    
    componentDidMount() {        
        if(!this.props.defaultFoco)
            return ;
        
        this.foco(this.props.nome);
    }
    
    render() {
        return (
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg}
                style={this.props.style}
            >              
                <div className={this.classErro()} >  
                    <label htmlFor={this.props.nome}>
                        {this.props.children}

                        {
                            this.props.tooltip !== '' &&                                                                                
                            <button 
                                type="button" 
                                className={"btn btn-secondary my-tooltip " + (this.state.tooltip ? 'active' : '')}
                                style={{
                                    
                                }}                                
                                onClick={() => this.setState({tooltip: !this.state.tooltip})}
                                onBlur={() => this.setState({tooltip: false})} >
                                <i className="fa fa-question-circle" aria-hidden="true"></i>

                                <span className="my-tooltiptext">
                                    {this.props.tooltip}
                                </span>
                            </button>                            
                        }
                    </label>

                    <div className="row">
                        {
                            this.props.symbol &&                        
                            <div 
                                className="col-md-2 
                                        col-sm-2
                                        col-lg-2
                                        col-xs-2"
                                style={{
                                    fontSize: '22px',
                                    lineHeight: '34px',
                                    fontWeight: 700,
                                    color: '#a6a5a5'
                                }}
                            >
                                {this.props.symbol}
                            </div>
                        }
                        
                        <div className={"col-md-" + (this.props.symbol ? '10' : '12') + " col-sm-" + (this.props.symbol ? '10' : '12') + " col-lg-" + (this.props.symbol ? '10' : '12') + " col-xs-" + (this.props.symbol ? '10' : '12')}>
                            <CurrencyInput
                                className="form-control"
                                style={{
                                    fontSize: (this.props.symbol ? '22' : '14') + 'px',
                                    lineHeight: (this.props.symbol ? '25' : '20') + 'px',
                                    fontWeight: (this.props.symbol ? '500' : '400')
                                }}
                                id={this.props.id}
                                name={this.props.name}
                                ref={this.props.ref}
                                value={this.props.value}
                                decimalSeparator=","
                                thousandSeparator="."
                                disabled={this.props.disabled}
                                onChangeEvent={(e, maskedValue, floatValue) => this.props.onChangeEvent(e, maskedValue, floatValue)}
                            />  
                        </div>
                    </div>                    

                    <span className="help-block">
                        {this.erro()}
                    </span>
                </div>
            </Col>
        )
    }
}

InputMoeda.defaultProps = {
    md: 12,
    className: '',
    tooltip: ''
};

export default InputMoeda;